import React from 'react';

const FragmentWrapper: React.FunctionComponent = ({ children }) => {
  return <>{children}</>;
};
export default FragmentWrapper;
